import config from "@/config"
import http from "@/utils/request"

export default {
	list: {
		url: `${config.MAIN_URL}/admin/api/company`,
		name: '获取企业列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	invitationCode: {
		url: `${config.MAIN_URL}/api/v1/company/invite/code`,
		name: '获取企业邀请码',
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	// 角色管理管理
	role: {
		url: {
			list: {
				url: `${config.MAIN_URL}/permission/role/roleList`,
				name: "角色列表",
			},
			add: {
				url: `${config.MAIN_URL}/permission/role/addRole`,
				name: "角色新增",
			},
			update: {
				url: `${config.MAIN_URL}/permission/role/updateRole`,
				name: "角色修改",
			},
			delete: {
				url: `${config.MAIN_URL}/permission/role/deleteRole`,
				name: "角色删除",
			},
			band: {
				url: `${config.MAIN_URL}/permission/user/rebandUserRoles`,
				name: "绑定角色",
			},
			getRoleMenus: {
				url: `${config.MAIN_URL}/permission/role/getRoleMenus`,
				name: "角色菜单获取",
			},
			getUserRoles: {
				url: `${config.MAIN_URL}/permission/user/getUserRoles`,
				name: "获取用户角色",
			},
		},
		get: async function (params) {
			return await http.get(this.url.list.url, params);
		},
		post: async function (params) {
			return await http.post(this.url.add.url, params);
		},
		put: async function (params) {
			return await http.put(this.url.update.url, params);
		},
		delete: async function (params) {
			return await http.delete(this.url.delete.url + params);
		},
		band: async function (params) {
			return await http.post(this.url.band.url, params);
		},
		getRoleMenus: async function (params) {
			return await http.get(this.url.getRoleMenus.url, params);
		},
		getUserRoles: async function (params) {
			return await http.get(this.url.getUserRoles.url, params);
		},

	},
}
